import React from "react";
import SlideredNumberSetting from "fantastic/components/common/controls/SlideredNumberSetting";
import imageContainerWidth from "fantastic/lib/imageContainerWidth";
import utils from "fantastic/lib/utils";

const ImageSizeSetting = props => {
  const {
    selected,
    width,
    update,
    paddingLeft,
    paddingRight,
    naturalWidth,
    fixedWidth
  } = props;
  const { px } = utils;
  const containerFreeSpace = imageContainerWidth(selected) - paddingLeft - paddingRight;
  const imageMaxWidth = containerFreeSpace < naturalWidth ? containerFreeSpace : naturalWidth;

  const handleChange = (value) => {
    const newWidth = parseInt(value);
    const attrs = {
      width: newWidth,
      fixed_width: !isAutoMode(newWidth)
    };
    update(selected, attrs);
  };

  const isAutoMode = (newWidth) => containerFreeSpace === newWidth || newWidth === naturalWidth;

  const note = () => {
    if (fixedWidth === true) return px(width);
    return isAutoMode(width) ? i18n.t('auto') : px(width);
  };

  const onChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  return (<>
    <SlideredNumberSetting
      min={5}
      max={imageMaxWidth}
      step={1}
      value={width}
      label={ i18n.t('size') }
      note={note()}
      displayInput={false}
      onChange={handleChange}
    />
  </>);
};

export default ImageSizeSetting;
